import { render } from "./DocumentReportExportedDocuments.vue?vue&type=template&id=2117b053&scoped=true&ts=true"
import script from "./DocumentReportExportedDocuments.vue?vue&type=script&lang=ts"
export * from "./DocumentReportExportedDocuments.vue?vue&type=script&lang=ts"

import "./DocumentReportExportedDocuments.vue?vue&type=style&index=0&id=2117b053&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2117b053"]])

export default __exports__